import { defineComponent } from "vue";

import { ForgotComponent, PAGE_NAME } from "./attributes";

import { SharedAuthCard } from "@/components/shared";
import { UILink } from "@/components/ui";
import {
  ForgotEmail,
  ForgotVerification,
  ForgotPassword,
} from "@/components/pages/forgot";

import { NotifcationFactory } from "@/shared/factory/notification";
import {
  DEFAILT_SECONDS,
  NotificationIcon,
  NotificationLabel,
  NotificationTitle,
} from "@/shared/constants/constants";
import { AuthForgotRequestFactory } from "@/shared/repository/modules/auth/factory";
import { RoutesName } from "@/shared/constants/enums";

type DisplayedComponent =
  | typeof ForgotEmail
  | typeof ForgotVerification
  | typeof ForgotPassword;

export default defineComponent({
  name: PAGE_NAME,
  components: {
    SharedAuthCard,
    UILink,
    ForgotEmail,
    ForgotVerification,
    ForgotPassword,
  },
  data() {
    return {
      loading: false,
      authForgotRequest: AuthForgotRequestFactory(),
      component: ForgotComponent.email,
      isVerification: false,
      notificationRepo: this.$projectServices.notificationRepo,
      authRepository: this.$projectServices.authRepository,
    };
  },
  computed: {
    displayedComponent(): DisplayedComponent {
      switch (this.component) {
        case ForgotComponent.email:
          return ForgotEmail;
        case ForgotComponent.verification:
          return ForgotVerification;
        case ForgotComponent.password:
          return ForgotPassword;
        default:
          return ForgotEmail;
      }
    },
  },
  methods: {
    async handleNext(): Promise<void> {
      try {
        this.loading = true;

        await this.authRepository
          .emailCode(this.authForgotRequest.email)
          .then(() => {
            this.component = ForgotComponent.verification;
          });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async handleVerification(code: string): Promise<void> {
      try {
        this.loading = true;

        await this.authRepository
          .codeVerification({
            code,
            email: this.authForgotRequest.email,
          })
          .then(() => {
            setTimeout(() => {
              this.component = ForgotComponent.password;
            }, DEFAILT_SECONDS);
            this.isVerification = true;
          });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async handleForgot(): Promise<void> {
      try {
        this.loading = true;

        await this.authRepository.forgot(this.authForgotRequest).then(() => {
          this.notificationRepo.updateNotification(
            NotifcationFactory({
              title: NotificationTitle.password,
              label: NotificationLabel.password,
              icon: NotificationIcon.password,
            })
          );

          this.$router.push({ name: RoutesName.login });
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
